import React from 'react';

const CareersInsights: React.FC = () => {
  const insights = [
    {
      icon: '☁️',
      category: 'Culture',
      title: 'Inside our Cloud Engineering Pods',
      link: '#'
    },
    {
      icon: '🤖',
      category: 'Technology',
      title: 'How we bring AI to real-world education',
      link: '#'
    },
    {
      icon: '🎓',
      category: 'Programs',
      title: 'From classroom to production: a trainee\'s journey',
      link: '#'
    },
    {
      icon: '📊',
      category: 'Technology',
      title: 'Building data pipelines that scale with learning',
      link: '#'
    }
  ];

  return (
    <section className="careers-section careers-insights">
      <div className="container">
        <h2 className="section-title">Life at Global Sansys</h2>
        <p className="section-subtitle">
          Get an inside look at our culture, projects, and the people who make it all happen.
        </p>
        
        <div className="insights-grid">
          {insights.map((insight, index) => (
            <div key={index} className="insight-card">
              <div className="insight-image">{insight.icon}</div>
              <div className="insight-content">
                <span className="insight-category">{insight.category}</span>
                <h3>{insight.title}</h3>
                <a href={insight.link} className="insight-link">Read more →</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CareersInsights;